// src/components/FeedbackSnackbar.js

import React from "react";
import { Snackbar, Alert } from "@mui/material";

function FeedbackSnackbar({ open, handleClose, message, severity }) {
  return React.createElement(
    Snackbar,
    {
      open: open,
      autoHideDuration: 6000,
      onClose: handleClose,
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
    },
    React.createElement(
      Alert,
      {
        onClose: handleClose,
        severity: severity,
        sx: { width: "100%" },
      },
      message
    )
  );
}

export default FeedbackSnackbar;
